import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { HOME_CONTENT_MOCK } from '../page/home/data/home-content.mock';
import type { HomeCuentaPerfil } from '../page/home/components/home-cuenta/home-cuenta.component';

/**
 * Compatibilidad NeoCampania: URLs legacy
 * `/microempresario/registro/:persona/:id/:token` → Home canónico con query.
 */
export const campaniaRegistroRedirectGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const persona = String(route.paramMap.get('persona') || '').toLowerCase();
  const id = route.paramMap.get('id');
  const token = route.paramMap.get('token');

  const perfil: HomeCuentaPerfil =
    persona === 'persona-juridica' || persona === 'juridica'
      ? 'juridica'
      : 'natural';

  return router.createUrlTree(['/home'], {
    queryParams: {
      perfil,
      ...(id ? { id } : {}),
      ...(token ? { token } : {}),
    },
    fragment: HOME_CONTENT_MOCK.anchors.creaCuenta,
  });
};
